import {
    Button,
    Grid,
    Space,
    Table,
    Tooltip
} from "antd";
import { Column } from "components";
import {
    StyledTableHeader,
    StyledTableWrapper,
} from "components/table/table.styled";
import { usePermissions } from "features/users";
import { useState } from "react";
import { EditOutlined } from "@ant-design/icons";
import { AddTargetModal } from "./target-modal";

const { useBreakpoint } = Grid;

export const BoothtargetTable = ({
    data,
    refetch
}: any) => {
    const screens = useBreakpoint();
    const permissions = usePermissions();

    const [organizerData, setOrganizerData] = useState<any>(null);
    const [showAddEventModal, setShowAddEventModal] = useState<boolean>(false);

    if (!permissions) return null;

    // ✅ Convert object -> array & handle "No record found"
    let dataSource: any[] = [];

    if (Array.isArray(data)) {
        dataSource = data;
    } else if (data && data.ResponseMessage === "No record found") {
        dataSource = []; // empty table
    } else if (data) {
        dataSource = [data];
    }

    const handleCloseModal = () => {
        setShowAddEventModal(false);
        setOrganizerData(undefined);
        document.body.style.overflow = "visible";
    };

    const handleOpenModal = (record: any) => {
        setShowAddEventModal(true);
        setOrganizerData(record);
        document.body.style.overflow = "hidden";
    };

    const tableWidth = screens.xxl ? { x: 1000 } : { x: 1000 };

    return (
        <>
            <div className={`cstmrightmdl ${showAddEventModal && "show"}`}>
                <AddTargetModal
                    onClose={handleCloseModal}
                    organizerData={organizerData}
                    showAddEventModal={showAddEventModal}
                    refetch={refetch}
                />
            </div>

            <StyledTableWrapper>
                <StyledTableHeader></StyledTableHeader>

                <Table
                    className="cstltblwthldr"
                    dataSource={dataSource}
                    rowKey="EventId"
                    scroll={tableWidth}
                    locale={{ emptyText: "No record found" }} // ✅ custom message
                >
                    <Column
                        title={"Event Name"}
                        dataIndex={"EventName"}
                        ellipsis
                    />
                    <Column
                        title={"Target Value"}
                        dataIndex={"TargetValue"}
                        ellipsis
                    />
                    <Column
                        title={"Action"}
                        render={(_: any, record: any) => (
                            <Space>
                                <Tooltip title="Edit">
                                    <Button
                                        size="small"
                                        shape="circle"
                                        icon={<EditOutlined />}
                                        onClick={() => handleOpenModal(record)}
                                    />
                                </Tooltip>
                            </Space>
                        )}
                    />
                </Table>
            </StyledTableWrapper>
        </>
    );
};
